export function getClerkHeader(token?: string | null)
{
return token?{'Authorization': `Bearer ${token}`}:{};
}

